'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import CheckBoxCheckedIcon from '@mui/icons-material/CheckBox';
import CheckBoxIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonIcon from '@mui/icons-material/RadioButtonUnchecked';
import { styled } from '@mui/material/styles';
const IconWrapper = styled('span', {
    shouldForwardProp: (prop) => !/checked|type/.test(prop)
})(({ theme, checked }) => ({
    display: 'inline-flex',
    color: /mixed|true/.test(checked.toString()) ? theme.tokens.FuelColorBrandPrimary : theme.tokens.FuelColorGray400
}));
const iconMap = {
    radio: {
        true: RadioButtonCheckedIcon,
        false: RadioButtonIcon,
        mixed: RadioButtonIcon
    },
    checkbox: {
        true: CheckBoxCheckedIcon,
        false: CheckBoxIcon,
        mixed: IndeterminateCheckBoxIcon
    }
};
export const SelectItemIndicator = (props) => {
    const Icon = iconMap[props.type][props.checked.toString()];
    return (_jsx(IconWrapper, { ...props, role: 'presentation', children: _jsx(Icon, {}) }));
};
